import React, { useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AccountDeletionForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleConfirm = () => {
    if (!name.trim() || !email.trim() || !reason.trim()) {
      Swal.fire("Please fill out all fields.", "", "warning");
      return;
    }

    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setName("");
      setEmail("");
      setReason("");

      Swal.fire({
        icon: "success",
        title: "Your request has been submitted",
        timer: 2000,
        showConfirmButton: false,
      });

      // 🔥 API call to delete account goes here
    }, 2000);
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        margin: "100px auto",
        padding: 4,
        boxShadow: 3,
        borderRadius: 2,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="h5" gutterBottom color="error">
        Delete Account
      </Typography>

      <TextField
        margin="dense"
        label="Name"
        fullWidth
        variant="outlined"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <TextField
        margin="dense"
        label="Email"
        fullWidth
        type="email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <TextField
        margin="dense"
        label="Reason for Deleting Account"
        fullWidth
        multiline
        rows={3}
        variant="outlined"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />

      <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
        <Button
          variant="outlined"
          color="primary"
          disabled={loading}
          onClick={() => navigate("/login")}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={loading}
          onClick={handleConfirm}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Confirm"}
        </Button>
      </Box>
    </Box>
  );
};

export default AccountDeletionForm;
